import { takeLatest, all, spawn } from 'redux-saga/effects';
import * as types from '../Actions/types';
import registerSaga from './registerSaga';
import patientSaga from './patientSaga';
// import watch1 from './index1';
//import watch2 from './index2';

export default function* watch() {
    yield all([takeLatest(types.VALIDATION_USERNAME_REQUEST, registerSaga)]);
    yield all([takeLatest(types.CHECK_PATIENT_EXISTS_REQUEST, registerSaga)]);
    yield all([takeLatest(types.VERIFY_2FACODE_REQUEST, registerSaga)]);
    yield all([takeLatest(types.REGISTER_REQUEST, registerSaga)]);
    yield all([takeLatest(types.GET_PATIENT_DETAILS, patientSaga)]);
    yield all([takeLatest(types.VALID_CLIENT_REQUEST, patientSaga)]);
    yield all([takeLatest(types.GET_CHILDREN_REQUEST, patientSaga)]);
    yield all([takeLatest(types.ADD_CHILDREN_REQUEST, patientSaga)]);
    yield all([takeLatest(types.ADD_USER_DETAILS_REQUEST, patientSaga)]);
    yield all([takeLatest(types.GET_CHECK_USER_DETAILS_SIGNED, patientSaga)]);
    yield all([takeLatest(types.GET_DOC_REQUEST, patientSaga)]);
    yield all([takeLatest(types.CHECK_ROOM_STATUS_REQUEST, patientSaga)]);
    yield all([takeLatest(types.GENERATE_CALLID_REQUEST, patientSaga)]);
    yield all([takeLatest(types.UPDATE_ROOM_STATUS, patientSaga)]);
    yield all([takeLatest(types.ADD_USER_TO_WAITING_REQUEST, patientSaga)]);
    yield all([takeLatest(types.UPLOAD_MEDICATIONS, patientSaga)]);
    yield all([takeLatest(types.GET_ROOM_KEYS_REQUEST, patientSaga)]);
    yield all([takeLatest(types.CALL_END_BY_PATIENT_REQUEST, patientSaga)]);
    yield all([takeLatest(types.PROVIDER_SETTINGS_REQUEST, patientSaga)]);
    yield all([takeLatest(types.NOTIFY_PROVIDER_REQUEST, patientSaga)]);
    yield all([takeLatest(types.DISCONNECT_REASON_REQUEST, patientSaga)]);
    yield all([takeLatest(types.CLEAR_DATA_REQUEST, patientSaga)]);
    yield all([takeLatest(types.ALLERGY_SEARCH, patientSaga)]);
    yield all([takeLatest(types.MEDICATION_SEARCH, patientSaga)]);
    yield all([takeLatest(types.ADD_FAMILY_MEMBER_REQUEST, patientSaga)]);
    //   yield spawn(watch1);
    //   yield spawn(watch2);
}
